import React from "react";
import { bool, node, string } from "prop-types";

import ContactBoxHeader from "../ContactBoxHeader";
import * as S from "./styled";

const ContactBox = ({
  children,
  className,
  header,
  isMobile,
  noPadding,
  ...props
}) => (
  <S.ContactBoxWrapper className={className} isMobile={isMobile} {...props}>
    {header && (
      <ContactBoxHeader isMobile={isMobile}>{header}</ContactBoxHeader>
    )}
    <S.ContactBoxContents noPadding={noPadding}>
      {children}
    </S.ContactBoxContents>
  </S.ContactBoxWrapper>
);

ContactBox.propTypes = {
  children: node,
  className: string,
  header: node,
  isMobile: bool,
  noPadding: bool
};

ContactBox.defaultProps = {
  children: null,
  className: null,
  header: null,
  isMobile: false,
  noPadding: false
};

export default ContactBox;
